<template>
  <div class="filters">
    <!-- <label for="region-select" class="select-label">Välj välfärdsområde:</label>
    <select v-model="selectedRegion" class="yddviz-select" id="region-select">
      <option v-for="region in regions" :value="region" :key="region.id">
        {{ region[`short_name_${lang}`] }}
      </option>
    </select> -->
    <v-select class='select' v-model='selectedRegion' :clearable='false' :options='selectOptions' @change='handleChange'>
      <template v-slot:no-options='{ searching }'>
        <template v-if='searching' class='no-options'>
          Ei tuloksia.
        </template>
      </template>
    </v-select>
    <fieldset class="radio-filters">
      <legend class="select-label">Lajittele:</legend>
      <label for="sort-3"><input type="radio" id="sort-3" :value="false" v-model="reverseOrder"> Mielipiteitä jakavimmat</label>
      <label for="sort-4"><input type="radio" id="sort-4" :value="true" v-model="reverseOrder"> Yhtenäisimmät mielipiteet</label>
    </fieldset>
  </div>
  <div class="questions-wrapper">
    <div v-for="id in filteredQuestions" :key="id" class="question">
      <LikertChart :data="questions ? questions.get(id) : null" :title="questionNames[id][lang]" :region="selectedRegion" />
    </div>
    <button class="yddviz-button" v-if="limit < questionIds.length" @click="limit += 3">Näytä lisää</button>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import loadData from '../utils.js'
import LikertChart from '../components/LikertChart.vue'

import regions from '../data/hva_meta.json'
import questionNames from '../data/questions.json'
import sortings from '../data/sortings.json'

export default {
  name: 'CompareParties',
  components: {
    vSelect,
    LikertChart,
  },
  props: {
    region: String,
  },
  data() {
    return {
      regions,
      sortings,
      selectedRegion: null,
      selectOptions: [],
      questions: null,
      questionNames,
      limit: 3,
      reverseOrder: false,
    }
  },
  created() {
    this.populateSelectOptions();
    /* if (this.region) {
      this.selectedRegion = this.regions.find(d => d.abbr_fi === this.region);
      console.log(this.selectedRegion);
    }
    else {
      this.selectedRegion = regions[0];
      console.log(this.selectedRegion);
    } */
  },
  watch: {
    selectedRegion(region) {
      loadData(region.id).then((response) => {
        this.limit = 3;
        this.questions = response;
      });
    },
  },
  computed: {
    questionIds() {
      console.log(this.sortings[this.selectedRegion.id]);
      return this.sortings[this.selectedRegion.id]
    },
    filteredQuestions() {
      let questions = this.questionIds.slice();
      if (this.reverseOrder) {
        questions.reverse();
      }
      return questions.slice(0, this.limit);
    },
  },
  methods: {
    populateSelectOptions() {
      let selectOptionArray = [];
      let sortedData = regions;
      sortedData.sort((a,b) => a['short_name_fi'] > b['short_name_fi'] ? 1 : b['short_name_fi'] > a['short_name_fi'] ? -1 : 0);
      selectOptionArray.push({label: 'Koko maa', loc: 'koko maassa', value: '00', id: '00' });
      for (let i = 1; i < sortedData.length; i++) {
        selectOptionArray.push({label: sortedData[i]['short_name_fi'], loc: sortedData[i]['short_name_fi_loc'], value: sortedData[i].id, id: sortedData[i].id });
      }
      this.selectOptions = selectOptionArray;
      this.selectedRegion = selectOptionArray.find(d => d.label === 'Koko maa');
    },
  },
  handleChange(value) {
    if (this.selectOptions.includes(value)) {
      this.selectedRegion = value;
    }
  },
}
</script>
